import { DragHandle } from "@mui/icons-material";
import { TextFieldProps } from "@mui/material";
import { useRef } from "react";
import { TextField } from "../textField";

export const ResizableTextField: React.FC<TextFieldProps & { viewOnly?: boolean }> = ({ viewOnly = false, ...props }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleMouseDown = (e: React.MouseEvent<SVGSVGElement, MouseEvent>, containerRef: React.RefObject<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        const container = containerRef.current;
        if (container) {
            const startY = e.clientY;
            const startHeight = container.offsetHeight;

            const handleMouseMove = (e: any) => {
                const newHeight = Math.max(40, startHeight + (e.clientY - startY)); // Minimum height of 40px
                container.style.height = `${newHeight}px`;
            };

            const handleMouseUp = () => {
                document.removeEventListener("mousemove", handleMouseMove);
                document.removeEventListener("mouseup", handleMouseUp);
            };

            document.addEventListener("mousemove", handleMouseMove);
            document.addEventListener("mouseup", handleMouseUp);
        }
    };

    return (
        <div
            ref={containerRef}
            style={{
                position: "relative",
                width: "100%", // Fixed width
                height: "100%", // Initial height
                marginBottom: "20px",
            }}
        >
            <TextField
                {...props}
                sx={{
                    height: "100% !important",
                    ".MuiInputBase-root": {
                        height: "100% !important", // Match TextField height to the container
                        overflow: "auto", // Allow scrolling if the content exceeds the height
                    },
                    '.MuiOutlinedInput-input': {
                        height: "100% !important", // Match TextField height to the container
                        overflow: "auto", // Allow scrolling if the content exceeds the height
                    }
                }}
                viewOnly={viewOnly}
            />
            {!viewOnly &&
                <DragHandle
                    onMouseDown={(e) => handleMouseDown(e, containerRef)}
                    style={{
                        position: "absolute",
                        bottom: 0,
                        left: "50%",
                        transform: "translateX(-50%)",
                        cursor: "ns-resize",
                    }}
                />
            }
        </div>
    );
};